module.exports = "Docs\n===\n\nComponents to display documentation\n"


//////////////////
// WEBPACK FOOTER
// ./src/Docs/README.md
// module id = 151
// module chunks = 0